module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7Amm0A/tc-custom/9781607052302.jpg?1737330896082",
      "alt": "This image is the cover for the book Crazy-Quilted Memories"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crazy-Quilted Memories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Turn family photos and mementos into quilted scrapbooks with this crazy quilting guide featuring 10 projects and 24 embroidery stitches.")]), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("Crazy-Quilted Memories")]), _vm._v(", quilt artist Brian Haggard shows readers how to turn treasured family keepsakes—including photo prints, buttons, beads, and other keepsakes—into meaningful quilt embellishments. He offers a fresh take on traditional crazy quilt techniques, as well as 24 basic and combination embroidery stitches to create never-before-seen motifs. "), _c('br'), _c('br'), _vm._v("Each of the 10 projects featured in this volume will tell a story about your life and family history in unique and creative ways. Lovingly stitched by hand, these small, portable projects are destined to become prized family heirlooms for generations to come.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brian Haggard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Brian Haggard Bio: Brian Haggard is an award-winning floral designer and owns an interior design business. Thousands of students have enjoyed Brian’s classes across the U.S., Canada, Ireland, and France. He lives in Indianapolis with his husband, Kevin, in The Crazy Haberdasher’s Studio. brianhaggard.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0